import {styled} from '@mui/material';
import {TimelineItem, TimelineDot, TimelineContent} from '@mui/lab';
import {StyledTimelineContentProps} from './types';

const StyledTimelineItem = styled(TimelineItem)`
	min-height: 58px;
	&::before {
		flex: 0;
		padding: 0;
	}
`;

const StyledTimelineDot = styled(TimelineDot)`
	padding: 1px;
	margin-top: ${({theme}) => theme.spacing(1)};
	margin-bottom: 0;
	border-width: 1px;
	box-shadow: none;
`;

const StyledTimelineContent = styled(TimelineContent)<StyledTimelineContentProps>`
	padding: ${({theme, customPaddingBottom}) =>
		customPaddingBottom
			? `0 ${theme.spacing(1.5)} ${theme.spacing(2)}`
			: `0 ${theme.spacing(1.5)}`};
`;

export {StyledTimelineItem, StyledTimelineDot, StyledTimelineContent};
